/*
 *  (c) 2015 - 2023 ENISCO by FORCAM GmbH
 */

import {TextField} from '@mui/material'
import React, {ChangeEvent} from 'react'
import {Locale, locales, useLocale, useUserName} from '@enisco/mcc-react-lib'
import {FormattedMessage} from 'react-intl'
import Autocomplete from '@mui/material/Autocomplete'
import useProfile from '../../../../hooks/useProfile'

const Localization: React.FC = () => {
  const [locale, setLocale] = useLocale()
  const [, setProfile] = useProfile()
  const userName = useUserName()

  const selectedLocale = locales.find((loc) => loc.key === locale)

  const onChange = (event: ChangeEvent<any>, newValue: Locale) => {
    setLocale(newValue.key)
    if (userName) setProfile({locale: newValue.key})
  }

  return (
    <Autocomplete
      sx={{width: '284px'}}
      value={selectedLocale}
      onChange={onChange}
      id='select-locale'
      data-testid='select-locale'
      disableClearable
      getOptionLabel={(option) => option.description}
      options={locales}
      renderInput={(params) => (
        <TextField
          {...params}
          label={
            <FormattedMessage
              id='MyProfileDialog.Localization'
              defaultMessage='Localization'
            />
          }
        />
      )}
    />
  )
}

export default Localization
